"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[969],{

/***/ 50969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ProductDrawer": function() { return /* binding */ ProductDrawer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50930);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(45680);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61702);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80748);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47825);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(64631);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85050);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(20784);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(85214);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(26993);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(54481);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(29894);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(75158);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(44373);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(80562);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(93481);
/* harmony import */ var _mui_icons_material_ArrowBack__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(21023);
/* harmony import */ var _mui_icons_material_CloseRounded__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(36191);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mui_icons_material__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(6571);
/* harmony import */ var _mui_icons_material_ChevronRightRounded__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(77214);
/* harmony import */ var _utils_formatters_CurrencyFormatter__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(23239);
/* harmony import */ var _config_environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60031);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8881);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13264);
/*
 * File: productDrawer.tsx
 * Project: meki
 * File Created: Monday, 12th July 2021 1:09:57 pm
 * Author: Luis Aparicio (luis@inventures.cl)
 * -----
 * Last Modified: Monday, 20th November 2023 12:16:37 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
















var range = function(props) {
    return Array.from({
        length: (props.stop - props.start) / props.step + 1
    }, function(_, i) {
        return props.start + i * props.step;
    });
};
var createPriceRanges = function(pricesRanges) {
    return pricesRanges.reduce(function(prev, current, i, array) {
        if (i == pricesRanges.indexOf(pricesRanges[0])) {
            return [
                {
                    start: current,
                    stop: undefined,
                    checked: false,
                    index: i
                }
            ];
        }
        if (i == pricesRanges.indexOf(pricesRanges[pricesRanges.length - 1])) {
            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(prev).concat([
                {
                    start: undefined,
                    stop: current,
                    checked: false,
                    index: i
                }, 
            ]);
        }
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(prev).concat([
            {
                start: array[i - 1],
                stop: array[i],
                checked: false,
                index: i
            }, 
        ]);
    }, [
        {}
    ]);
};
var ListItemTextPrimaryStyled = (0,_mui_system__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    "& .MuiListItemText-primary": {
        fontSize: 16,
        "&span": {
            fontSize: 16
        }
    }
});
var NestedListItem = (0,_mui_system__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(function(param) {
    var theme = param.theme;
    return {
        paddingLeft: theme.spacing(4)
    };
});
var ListItemSecondaryActionStyled = (0,_mui_system__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
    fontSize: 16,
    "&span": {
        fontSize: 16
    }
});
var DrawerStyled = (0,_mui_system__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)({
    "& .MuiDrawer-paper": {
        width: 340,
        "@media (min-width: 600px)": {
            width: 340
        }
    }
});
var AppBarStyled = (0,_mui_system__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
    top: 0,
    bottom: "auto"
});
var ToolbarStyled = (0,_mui_system__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
    justifyContent: "space-between",
    minHeight: 64
});
var TitleTypography = (0,_mui_system__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
    flexGrow: 1,
    paddingLeft: 13
});
var OptionList = (0,_mui_system__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
    paddingTop: 0,
    paddingBottom: 60
});
var FilterButtonDivAppBar = (0,_mui_system__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return {
        top: "auto",
        bottom: 0,
        left: 0,
        right: "auto",
        width: "inherit",
        backgroundColor: theme.palette.common.white
    };
});
var FilterButtonDivToolbar = (0,_mui_system__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
    justifyContent: "space-evenly"
});
var AplicationButton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
    height: 32,
    "& .MuiButton-Text": {
        width: 94,
        height: 24
    }
});
var ListItemTextTitleStyled = (0,_mui_system__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    "& .MuiListItemText-primary": {
        fontFamily: "Poppins",
        fontSize: 16,
        fontWeight: "normal",
        fontStretch: "normal",
        lineHeight: "normal",
        letterSpacing: 0.16
    }
});
var BrandListBadge = (0,_mui_system__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({
    marginRight: 21
});
function PriceStepItems(props) {
    var handleRangeSelect = props.handleRangeSelect, rangesDuos = props.rangesDuos;
    var currFormat = new _utils_formatters_CurrencyFormatter__WEBPACK_IMPORTED_MODULE_17__/* .CurrencyFormatter */ .J({
        fallback: _config_environment__WEBPACK_IMPORTED_MODULE_3__/* .NEXT_PUBLIC_NO_PRICE_FALLBACK */ .uh
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: rangesDuos.map(function(range, i) {
            var labelId = "checkbox-list-price-label-".concat(i);
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                        role: undefined,
                        dense: true,
                        button: true,
                        onClick: function() {
                            handleRangeSelect(range);
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                    edge: "start",
                                    checked: range.checked,
                                    tabIndex: -1,
                                    disableRipple: true,
                                    inputProps: {
                                        "aria-labelledby": labelId
                                    },
                                    color: "primary"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListItemTextPrimaryStyled, {
                                id: labelId,
                                primary: range.start && range.stop ? "".concat(currFormat.format(range.start), " - ").concat(currFormat.format(range.stop)) : range.start && !range.stop ? "Menos de ".concat(currFormat.format(range.start)) : !range.start && range.stop ? "M\xe1s de ".concat(currFormat.format(range.stop)) : "No Ranges"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        component: "li"
                    })
                ]
            }, i);
        })
    });
}
function BrandsItems(props) {
    var handleBrandItemClick = props.handleBrandItemClick, brandsList = props.brandsList, brandsCheckList = props.brandsCheckList;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: brandsList.map(function(brandInfo, i) {
            var ref;
            var labelId = "checkbox-list-brand-label-".concat(i);
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(NestedListItem, {
                        role: undefined,
                        dense: true,
                        onClick: function() {
                            handleBrandItemClick(brandInfo.brand);
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                    edge: "start",
                                    checked: (ref = brandsCheckList.find(function(b) {
                                        return b.brand === brandInfo.brand;
                                    })) === null || ref === void 0 ? void 0 : ref.checkState,
                                    tabIndex: -1,
                                    disableRipple: true,
                                    inputProps: {
                                        "aria-labelledby": labelId
                                    },
                                    color: "primary"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListItemTextPrimaryStyled, {
                                id: labelId,
                                primary: "".concat(brandInfo.brand)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListItemSecondaryActionStyled, {
                                children: "(".concat(brandInfo.quantity, ")")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        component: "li"
                    })
                ]
            }, i);
        })
    });
}
function ProductDrawer(props) {
    var ref, ref1, ref2, ref3;
    var handleToggleDrawer = props.handleToggleDrawer, toggleDrawer = props.toggleDrawer, data = props.data, handleTotalFiltersChecked = props.handleTotalFiltersChecked, setNavigating = props.setNavigating;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), openByBrand = ref4[0], setOpenByBrand = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), openByPrice = ref5[0], setOpenByPrice = ref5[1];
    var ranges = range({
        start: 5000,
        stop: 30000,
        step: 5000
    });
    var pricesRanges = createPriceRanges(ranges);
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(pricesRanges), INITIAL_STATE_RANGES = ref6.current;
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(INITIAL_STATE_RANGES), stateRanges = ref7[0], setStateRanges = ref7[1];
    var handleOnRangeClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(rangeClicked) {
        var updatedRangesState = stateRanges.map(function(range) {
            return range.index === rangeClicked.index ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)({}, range), {
                checked: !range.checked
            }) : range;
        });
        setStateRanges(updatedRangesState);
    }, [
        stateRanges
    ]);
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(data.brands.map(function(brand) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)({}, brand), {
            checkState: false
        });
    })), INITIAL_STATE_BRANDS = ref8.current;
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(INITIAL_STATE_BRANDS), brandsCheckList = ref9[0], setBrandsCheckList = ref9[1];
    var checkedItems = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            brands: brandsCheckList === null || brandsCheckList === void 0 ? void 0 : brandsCheckList.filter(function(brandSelected) {
                return brandSelected.checkState == true;
            }),
            priceRanges: stateRanges === null || stateRanges === void 0 ? void 0 : stateRanges.filter(function(range) {
                return range.checked == true;
            })
        };
    }, [
        brandsCheckList,
        stateRanges
    ]);
    var handleBrandItemClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(brandName) {
        var updateBrandItem = brandsCheckList.map(function(brandItem) {
            return brandItem.brand === brandName ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)({}, brandItem), {
                checkState: !brandItem.checkState
            }) : brandItem;
        });
        setBrandsCheckList(updateBrandItem);
    }, [
        brandsCheckList
    ]);
    var handleCleanFilter = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(function() {
        var newRoute;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setStateRanges(INITIAL_STATE_RANGES);
                    setBrandsCheckList(INITIAL_STATE_BRANDS);
                    newRoute = function() {
                        return {
                            pathname: router.pathname,
                            query: (0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .removeUndefineds */ .ox)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)({}, router.query), {
                                brands: undefined,
                                priceRanges: undefined,
                                sortBy: router.query.sortBy
                            }))
                        };
                    };
                    handleToggleDrawer();
                    setNavigating(true);
                    return [
                        4,
                        router.push(newRoute())
                    ];
                case 1:
                    _state.sent();
                    setNavigating(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        INITIAL_STATE_RANGES,
        INITIAL_STATE_BRANDS,
        router,
        handleToggleDrawer,
        setNavigating, 
    ]);
    var handleSubmit = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(function() {
        var brands, priceRanges, newRoute;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_24__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    brands = checkedItems.brands.length > 0 ? checkedItems.brands.map(function(brand) {
                        return brand.brand;
                    }).join() : undefined;
                    priceRanges = checkedItems.priceRanges.length > 0 ? checkedItems.priceRanges : undefined;
                    newRoute = function(brands, priceRanges) {
                        return {
                            pathname: router.pathname,
                            query: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)({}, router.query), {
                                brands: brands !== null && brands !== void 0 ? brands : brands,
                                priceRanges: priceRanges === null || priceRanges === void 0 ? void 0 : priceRanges.map(function(range) {
                                    if (!range.stop && !range.start) {
                                        return "";
                                    } else if (!range.start && range.stop) {
                                        return "stop:".concat(range.stop);
                                    } else if (range.start && !range.stop) {
                                        return "start:".concat(range.start);
                                    }
                                    return "start:".concat(range.start, ";stop:").concat(range.stop);
                                })
                            })
                        };
                    };
                    handleToggleDrawer();
                    setNavigating(true);
                    return [
                        4,
                        router.push(newRoute(brands, priceRanges))
                    ];
                case 1:
                    _state.sent();
                    setNavigating(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        handleToggleDrawer,
        router,
        checkedItems,
        setNavigating
    ]);
    var handleClickByBrand = function() {
        setOpenByBrand(!openByBrand);
    };
    var handleClickByPrice = function() {
        setOpenByPrice(!openByPrice);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function sumAllCheckFilter() {
        var ref, ref1;
        var totalChecks = (checkedItems === null || checkedItems === void 0 ? void 0 : (ref = checkedItems.brands) === null || ref === void 0 ? void 0 : ref.length) + (checkedItems === null || checkedItems === void 0 ? void 0 : (ref1 = checkedItems.priceRanges) === null || ref1 === void 0 ? void 0 : ref1.length);
        handleTotalFiltersChecked(totalChecks !== null && totalChecks !== void 0 ? totalChecks : 0);
    }, [
        checkedItems,
        handleTotalFiltersChecked
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function checkQueryParams() {
        var ref;
        var brandsQuery = (ref = router.query.brands) === null || ref === void 0 ? void 0 : ref.split(",");
        var updateBrandItem = brandsCheckList.map(function(brandItem) {
            return (brandsQuery === null || brandsQuery === void 0 ? void 0 : brandsQuery.find(function(brandQuery) {
                return brandItem.brand === brandQuery;
            })) ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)({}, brandItem), {
                checkState: true
            }) : brandItem;
        });
        setBrandsCheckList(updateBrandItem);
        if (router.query.priceRanges) {
            var queryRanges = [
                router.query.priceRanges
            ].flat().map(function(priceRange) {
                var queryRange = Object.fromEntries(priceRange.split(";").map(function(range) {
                    return range.split(":");
                }));
                return {
                    start: +(queryRange === null || queryRange === void 0 ? void 0 : queryRange.start) ? +queryRange.start : undefined,
                    stop: +(queryRange === null || queryRange === void 0 ? void 0 : queryRange.stop) ? +queryRange.stop : undefined
                };
            });
            var updatedRangesState = stateRanges.map(function(range) {
                return (queryRanges === null || queryRanges === void 0 ? void 0 : queryRanges.find(function(queryRange) {
                    return range.start === (queryRange === null || queryRange === void 0 ? void 0 : queryRange.start) && range.stop === (queryRange === null || queryRange === void 0 ? void 0 : queryRange.stop);
                })) ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)({}, range), {
                    checked: true
                }) : range;
            });
            setStateRanges(updatedRangesState);
        }
    }, [
        router.query
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(DrawerStyled, {
        anchor: "left",
        open: toggleDrawer,
        onClose: handleSubmit,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AppBarStyled, {
                position: "sticky",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ToolbarStyled, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                            onClick: handleToggleDrawer,
                            edge: "start",
                            color: "inherit",
                            "aria-label": "back",
                            size: "large",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ArrowBack__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TitleTypography, {
                            variant: "h6",
                            children: "Filtrar"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                            onClick: handleToggleDrawer,
                            edge: "end",
                            color: "inherit",
                            "aria-label": "back",
                            size: "large",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_CloseRounded__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(OptionList, {
                "aria-label": "options",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                        button: true,
                        onClick: handleClickByBrand,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListItemTextTitleStyled, {
                                primary: "Por marca"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BrandListBadge, {
                                badgeContent: (ref = checkedItems.brands) === null || ref === void 0 ? void 0 : ref.length,
                                hidden: ((ref1 = checkedItems.brands) === null || ref1 === void 0 ? void 0 : ref1.length) != 0,
                                color: "primary"
                            }),
                            openByBrand ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ChevronRightRounded__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
                        in: openByBrand,
                        timeout: "auto",
                        unmountOnExit: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            component: "div",
                            disablePadding: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BrandsItems, {
                                brandsCheckList: brandsCheckList,
                                brandsList: brandsCheckList,
                                handleBrandItemClick: handleBrandItemClick
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        component: "li"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                        button: true,
                        onClick: handleClickByPrice,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListItemTextTitleStyled, {
                                primary: "Por precio"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BrandListBadge, {
                                badgeContent: (ref2 = checkedItems.priceRanges) === null || ref2 === void 0 ? void 0 : ref2.length,
                                hidden: ((ref3 = checkedItems.priceRanges) === null || ref3 === void 0 ? void 0 : ref3.length) != 0,
                                color: "primary"
                            }),
                            openByPrice ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ChevronRightRounded__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
                        in: openByPrice,
                        timeout: "auto",
                        unmountOnExit: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            component: "div",
                            disablePadding: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PriceStepItems, {
                                rangesDuos: stateRanges,
                                handleRangeSelect: handleOnRangeClick
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        component: "li"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FilterButtonDivAppBar, {
                elevation: 4,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FilterButtonDivToolbar, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                color: "primary",
                                onClick: handleCleanFilter,
                                variant: "text",
                                children: "Limpiar"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AplicationButton, {
                                disabled: checkedItems.brands.length > 0 || checkedItems.priceRanges.length > 0 ? false : true,
                                color: "primary",
                                variant: "contained",
                                onClick: handleSubmit,
                                children: "Aplicar"
                            })
                        })
                    ]
                })
            })
        ]
    });
}


/***/ })

}]);